// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"322":"cde0f87e","496":"38d95697","807":"7dd5df39","927":"99849d77"}[chunkId] + ".chunk.js";
};